(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("AvgByBoxReportViewModel", AvgByBoxReportViewModelFactory);

  /** @ngInject */
  function AvgByBoxReportViewModelFactory(
    reportActions,
    reportsFilterStore,
    dispatcher,
    ActionTypesEnum,
    ByBoxrViewModel
  ) {
    function AvgByBoxReportViewModel() {
      this.exportToComponent = new ByBoxrViewModel();
      this._reportsFilterStoreChangeHandler = null;
      this.chartRegionCurrency = {
        data: null,
        chartType: "bar",
        rotated: true,
        x: {
          type: "category"
        },
        chartName: "regionCurrency"
      };
      this.chartTokens = {
        data: null,
        chartType: "bar",
        rotated: true,
        x: {
          type: "category"
        },
        chartName: "tokens"
      };

      init.call(this);
    }

    AvgByBoxReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return AvgByBoxReportViewModel;

    function init() {
      var that = this;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      if (reportFilterData.selectedFacilitySerial) {
        reportActions
          .getAvgMoneyByBox(
            reportFilterData.selectedFacilitySerial,
            reportFilterData.fromTimestamp,
            reportFilterData.toTimestamp,
            reportFilterData.currency
          )
          .then(function (successData) {
            var exportData =
              that.exportToComponent.createChartData(successData);

            exportData.regionCurrency.groupsData = sortBoxes(
              exportData.regionCurrency.groupsData
            );
            that.chartRegionCurrency.data = exportData.regionCurrency;

            exportData.tokens.groupsData = sortBoxes(
              exportData.tokens.groupsData
            );
            that.chartTokens.data = exportData.tokens;

            dispatcher.dispatch({
              type: ActionTypesEnum.HIDE_LOADER
            });
          });
      } else {
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      }

      return false;
    }

    function sortBoxes(groupsData) {
      return groupsData.sort(function (a, b) {
        var nameA = a.groupValue.toUpperCase(); // ignore upper and lowercase
        var nameB = b.groupValue.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    }
  }
})();
